import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AudioMessageModel } from '@store/slices/audioMessage.slice'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'

const sectionEndpoint = 'audio-message/'

export const createAudioMessageFromFile = createAsyncThunk(
  'audioMessage/createAudioFromFile',
  async (props: { data: Partial<AudioMessageModel>; file: File }) => {
    const formData = new FormData()

    // Append each key-value pair of `data` to `formData`
    Object.keys(props.data).forEach((key) =>
      formData.append(key, props.data[key])
    )

    // Append `file` to `formData`
    formData.append('audioFile', props.file)

    try {
      const response = await api.post(`${sectionEndpoint}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      return response.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se upravit/uložit zvukovou stopu'}`
        )
      } else {
        toast.error('Nepodařilo se upravit/uložit zvukovou stopu')
      }
      throw axiosError
    }
  }
)

export const updateAudioMessageWithFile = createAsyncThunk(
  'audioMessage/updateAudioWithFile',
  async (props: {
    id: EntityId
    data: Partial<AudioMessageModel>
    file: File
  }) => {
    const formData = new FormData()

    // Append each key-value pair of `data` to `formData`
    Object.keys(props.data).forEach((key) =>
      formData.append(key, props.data[key])
    )

    // Append `file` to `formData`
    if (props.file) formData.append('audioFile', props.file)

    try {
      const response = await api.put(
        `${sectionEndpoint}${props.id}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      return response.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se upravit/uložit zvukovou stopu'}`
        )
      } else {
        toast.error('Nepodařilo se upravit/uložit zvukovou stopu')
      }
      throw axiosError
    }
  }
)
